import React from "react";

interface TaskStatusBadgeProps {
    status: "not-started" | "in-progress" | "completed" | string;
    className?: string;
}

export const TaskStatusBadge: React.FC<TaskStatusBadgeProps> = ({
    status,
    className = "",
}) => {
    const statusConfig = {
        "not-started": {
            label: "Not Started",
            color: "#9CA3AF",
            bgColor: "#F3F4F6",
        },
        "in-progress": {
            label: "In Progress",
            color: "#3B82F6",
            bgColor: "#DBEAFE",
        },
        completed: {
            label: "Completed",
            color: "#10B981",
            bgColor: "#D1FAE5",
        },
    };

    const config = statusConfig[status] || statusConfig["not-started"];

    return (
        <span
            className={`inline-flex items-center justify-center rounded-full px-3 py-1 text-sm font-semibold shadow-sm transition-all duration-200 ${className}`}
            style={{
                backgroundColor: config.bgColor,
                color: config.color,
            }}
        >
            {config.label}
        </span>
    );
};

